window.Themes = function () {
    var el = this;

    el.data = {};

    el.show = function () {
        var templateData = [];
        for (var i in el.data) {
            var grid = $.extend(true, {}, el.data[i]);
            grid['id'] = i;
            var templateThemes = [];
            for (var j in grid.themes) {
                var theme = grid.themes[j];
                var templateImages = [];

                for (var k in theme.images) {
                    var image = theme.images[k];
                    templateImages.push(image);
                }

                theme.images = templateImages;
                templateThemes.push(theme);
            }
            grid.themes = templateThemes;
            templateData.push(grid);
        }
        if (templateData.length > 0 ){
            templateData[0].is_active = true;
        }

        el.dialog.show('backgrounds', {theme_groups: templateData});
    };

    el.selectTheme = function (gid, id) {
        var data = {
            company_id: el.data[gid].themes[id].company_id,
            theme_id: id,
            images: []
        };

        var i;
        var images = el.data[gid].themes[id].images;
        for (i in images) {
            if (images.hasOwnProperty(i)) {
                data.images.push({filename: el.data[gid].themes[id].images[i]});
            }
        }

        $('#background-content-1').addClass('hide');
        $('#background-content-2').removeClass('hide');
        var html = Mustache.render($('#theme-images-template').html(), data);
        $('#background-content-2 .modal-body').html(html);
    };

    el.selectBackground = function (companyId, themeId, name) {
        var className = 'backgrounds';
        var id = 1;
        var url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/themes/' + companyId + '/' + themeId + '/workimages/' + name;

        var image = new Image();
        image.onload = function () {
            el.upImages.onloadImage(this, className, el.selectWorkareaId, id, name, themeId, companyId);
            el.workarea.render();
            el.preview.update();
            
            el.dialog.hide('backgrounds');
        };

        image.src = url;
    };
    
    $('.js-themes-show').on('click', function() {el.show();});
    $(document).on('click', '.js-theme-show', function() {
        el.selectTheme($(this).attr('data-group'), $(this).attr('data-id'));
    });
    
    $(document).on('click', '.js-background-back', function() {
        $('#background-content-2').addClass('hide');
        $('#background-content-1').removeClass('hide');
    });
    
    $(document).on('click', '.js-theme-set', function() {
        var element = $(this);
        el.selectBackground(element.attr('data-company'), element.attr('data-id'), element.attr('data-filename'));
    });
};